export const setLicences = (licences) => ({
    type: "SET_LICENCES",
    payload: licences,
  });

  export const setAvailableLicences = (availableLicences) => ({
    type: "SET_AVAILABLE_LICENCES",
    payload: availableLicences,
  });